import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Field, reduxForm} from 'redux-form'
import FormInput from 'components/FormInput'
import Icon from 'components/Icon'
import validate from './validate'
import Button from 'components/Button'

class SignUpForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool
  }

  render() {
    const {handleSubmit, invalid, submitting} = this.props

    return (
      <form className='auth-view_form is-signup' onSubmit={handleSubmit}>
        <div className='auth-view_title'>Start your 30 day free trial</div>
        <div className='auth-view_subtitle'>No credit card required</div>
        <Field
          className='auth-view_form-field'
          name='name'
          placeholder='Your name'
          disabled={submitting}
          component={FormInput}
        />
        <Field
          className='auth-view_form-field'
          name='email'
          placeholder='Email'
          disabled={submitting}
          component={FormInput}
        />
        <Field
          className='auth-view_form-field'
          name='password'
          placeholder='Password'
          type='password'
          disabled={submitting}
          component={FormInput}
        />
        <Field
          className='auth-view_form-field'
          name='phone'
          type='tel'
          placeholder='Phone number'
          optional
          disabled={submitting}
          component={FormInput}
        />
        <Field
          className='auth-view_form-field auth-view_form-terms'
          name='terms'
          label={(
            <Fragment>
              I agree to Data-Driven{'\''}s <a target='_blank' href={`${__WWW_URL__}terms`}>Terms & Conditions</a>{' '}
              and <a target='_blank' href={`${__WWW_URL__}privacy`}>Privacy Policy</a>.
            </Fragment>
          )}
          type='checkbox'
          disabled={submitting}
          component={FormInput}
          inputType='transparent'
        />
        <Button disabled={invalid || submitting} color='green' type='submit'>
          Complete Registration
          <Icon className='auth-view_form_button_icon' name='arrow-button' size='23px' />
        </Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'signUp',
  validate
})(SignUpForm)



// WEBPACK FOOTER //
// ./client/views/AuthView/SignUpForm.js